var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFullscreenFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 6,
    fill: "black",
    fillOpacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4804 34.6079L13.4804 28.9216C13.4804 27.974 14.2485 27.2059 15.1961 27.2059C16.1436 27.2059 16.9118 27.974 16.9118 28.9216L16.9118 32.8922L21.0784 32.8922C22.026 32.8922 22.7941 33.6603 22.7941 34.6079C22.7941 35.5554 22.026 36.3235 21.0784 36.3235L15.1961 36.3235C14.7411 36.3235 14.3047 36.1428 13.9829 35.821C13.6612 35.4993 13.4804 35.0629 13.4804 34.6079Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0171 14.179C36.3388 14.5007 36.5196 14.9371 36.5196 15.3921L36.5196 21.0784C36.5196 22.026 35.7515 22.7941 34.8039 22.7941C33.8564 22.7941 33.0882 22.026 33.0882 21.0784L33.0882 17.1078L28.9216 17.1078C27.974 17.1078 27.2059 16.3397 27.2059 15.3921C27.2059 14.4446 27.974 13.6765 28.9216 13.6765L34.8039 13.6765C35.2589 13.6765 35.6953 13.8572 36.0171 14.179Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5196 34.6079L36.5196 28.9216C36.5196 27.974 35.7515 27.2059 34.8039 27.2059C33.8564 27.2059 33.0882 27.974 33.0882 28.9216L33.0882 32.8922L28.9216 32.8922C27.974 32.8922 27.2059 33.6603 27.2059 34.6079C27.2059 35.5554 27.974 36.3235 28.9216 36.3235L34.8039 36.3235C35.7515 36.3235 36.5196 35.5554 36.5196 34.6079Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4804 15.3921L13.4804 21.0784C13.4804 22.026 14.2485 22.7941 15.1961 22.7941C16.1436 22.7941 16.9118 22.026 16.9118 21.0784L16.9118 17.1078L21.0785 17.1078C22.026 17.1078 22.7941 16.3397 22.7941 15.3921C22.7941 14.4446 22.026 13.6765 21.0785 13.6765L15.1961 13.6765C14.2485 13.6765 13.4804 14.4446 13.4804 15.3921Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFullscreenFilled);
export default __webpack_public_path__ + "static/media/ic_fullscreen_filled.769323eda5d6f8a83cff2bad92c34ef7.svg";
export { ForwardRef as ReactComponent };